import { ResponsiveBar } from '@nivo/bar';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Card from '../components/Reusable/Card';
import Spinner from '../components/Reusable/Spinner';
import APIS from '../constant/Endpoint';
import useGetHook from '../customHooks/useGetHook';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import UsersIcon from '../Icons/UsersIcon';
import RoleIcon from '../Icons/RoleIcon';
import loadable from '@loadable/component';
import OverviewSkeleton from '../components/Reusable/OverviewSkeleton';
const OverviewComponent = loadable(
  () => import('../components/Overview/index')
);
const graphTheme = {
  // Tooltip shown while hovering bar
  tooltip: {
    container: {
      background: 'var(--primary-light)',
      borderRadius: '5px',
    },
  },
  text: {
    // Value writtrn inside bar
    fontSize: 20,
    fill: '#ffffff',
  },
  axis: {
    legend: {
      // X-axis and Y-axis label
      text: {
        fontSize: 16,
        fill: 'var(--primary)',
      },
    },
    domain: {
      //X-axis and Y-axis main line
      line: {
        strokeWidth: 2,
        stroke: 'var(--primary-light)',
      },
    },
    ticks: {
      //Small line extending left of y-axis
      line: {
        strokeWidth: 1,
        stroke: 'var(--primary-light)',
      },
      //Values of Y-axis
      text: {
        fontSize: 14,
        fill: 'var(--primary)',
      },
    },
  },
};

const UserOverview = () => {
  const navigate = useNavigate();
  const [themeColor, setThemeColor] = useState('');
  // const salesData = [
  //   { day: "Monday", Users: 120 },
  //   { day: "Tuesday", Users: 150 },
  //   { day: "Wednesday", Users: 200 },
  //   { day: "Thursday", Users: 170 },
  //   { day: "Friday", Users: 220 },
  //   { day: "Saturday", Users: 300 },
  //   { day: "Sunday", Users: 280 },
  // ];
  const style = document
    .querySelector('html')
    .getAttribute('style')
    ?.split(';');

  const colorScheme = useMemo(() => {
    const colors = {};
    if (style?.length) {
      style.map((e) => {
        const values = e.split(':');
        colors[values[0].replace('--', '')] = values[1];
      });
      return colors;
    }
  }, [style]);

  const { data, isLoading } = useGetHook({
    url: `${APIS.USER}overview/`,
    queryKey: ['user-role-overview'],
    params: {},
  });

  const { data: loginData, isLoading: isLoginDataloading } = useGetHook({
    url: `${APIS.LOGIN_HISTORY}`,
    queryKey: ['login-history'],
    params: {},
  });
  // console.log(loginData);

  useEffect(() => {
    setThemeColor(colorScheme?.['primary']);
  }, [colorScheme]);

  return (
    <>
      {isLoading || isLoginDataloading || !themeColor ? (
        <OverviewSkeleton />
      ) : (
        <OverviewComponent
          salesData={loginData}
          graphTheme={graphTheme}
          data={data}
          themeColor={themeColor}
        />
      )}
    </>
  );
};

export default UserOverview;
